import React from "react";
import SingleProgressLine from "../../../components/singleComponenets/SingleProgressLine";

const StatusOverview = ({
  users = {},
  cases = {},
  siteId = "all",
  loading = false,
}) => {
  const siteMap = {};
  const normalize = (name) => (name || "").trim();

  const userSites = users?.perSite || [];
  const caseSites = cases?.perSite || [];

  // Merge users by siteName
  userSites.forEach((u) => {
    const key = normalize(u.siteName);
    siteMap[key] = {
      siteId: u.siteId || key,
      name: normalize(u.siteName),
      users: u.users || 0,
      cases: 0,
    };
  });

  // Merge cases by siteName
  caseSites.forEach((c) => {
    const key = normalize(c.siteName);
    if (!siteMap[key]) {
      siteMap[key] = {
        siteId: key,
        name: normalize(c.siteName),
        users: 0,
        cases: c.cases || 0,
      };
    } else {
      siteMap[key].cases += c.cases || 0;
    }
  });

  // Convert to array
  let sites = Object.values(siteMap).sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  // If a specific site is selected, filter to only that one
  if (siteId !== "all") {
    sites = sites.filter((s) => s.siteId === siteId || s.name === siteId);
  }

  const totalCases = sites.reduce((sum, s) => sum + (s.cases || 0), 0);
  const totalUsers = sites.reduce((sum, s) => sum + (s.users || 0), 0);

  if (loading) {
    return (
      <div className="text-white">
        <span className="text-xl font-bold">Status Overview</span>
        <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />
        <div className="text-gray-400">Loading...</div>
      </div>
    );
  }

  if (!sites.length) {
    return (
      <div className="text-white">
        <span className="text-xl font-bold">Status Overview</span>
        <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />
        <div className="text-gray-400">No data available</div>
      </div>
    );
  }

  return (
    <div className="text-white">
      <span className="text-xl font-bold">Status Overview</span>
      <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />

      <div className="grid md:grid-cols-2 gap-10">
        {/* CASES */}
        <div>
          <div className="flex justify-between text-sm font-semibold h-[30px] mb-3">
            <p>Number of Cases</p>
            <p>Total cases {totalCases}</p>
          </div>
          {sites.map((site) => (
            <SingleProgressLine
              key={site.siteId || site.name}
              name={site.name}
              current={site.cases}
              total={totalCases || 1}
            />
          ))}
        </div>

        {/* USERS */}
        <div>
          <div className="flex justify-between text-sm font-semibold h-[30px] mb-3">
            <p>Number of Users</p>
            <p>Total users {totalUsers}</p>
          </div>
          {sites.map((site) => (
            <SingleProgressLine
              key={site.siteId || site.name}
              name={site.name}
              current={site.users}
              total={totalUsers || 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusOverview;
